<template>
	<div class="ele-color">
		<div class="color-title">
		<span>配色方案</span>
		</div>
	<div class="color-content">
	<ul><li v-for="(item,index) in bgColorConfig" :key="index" :class="(index==themecolor)?'layui-this':''" @click="changeTheme(index)">
			<div  data-skin="skin-blue" style="" class="clearfix full-opacity-hover">				
				<div>
					<span :style="{ display:'block', width: '20%',float: 'left',height: '12px',background:item.headerLogoBg }"></span>
					<span :style="{ display:'block',width: '80%', float: 'left', height: '12px', background:item.headerRightBg }"></span>
				</div>
				<div>
				<span :style="{ display:'block',width: '20%',float: 'left',height: '40px',background:item.leftMenuBg }"></span>
				<span style="display:block; width: 80%; float: left; height: 40px; background: #ffffff;"></span>
				</div>
			</div>
		</li>
		</ul>
	</div>	
	<el-descriptions class="margin-top" :column="1" border>
		<el-descriptions-item>
			<template slot="label">
				主题
			</template>
			<ThemePicker :default="defaulttheme" style="float: left;height: 26px;margin: -3px 8px 0 0;" @change="themeChange" />
		</el-descriptions-item>	
		<el-descriptions-item>
			<template slot="label">
				菜单位置
			</template>
			 <el-radio-group v-model="menuLayout" @change="changeLayout">
			      <el-radio-button :label="0">左侧</el-radio-button>
			      <el-radio-button :label="1">顶部</el-radio-button>
			      <el-radio-button :label="2">混合</el-radio-button>
			    </el-radio-group>
		</el-descriptions-item>	
		<el-descriptions-item>
			<template slot="label">
				多页签
			</template>
			 <el-switch
			 :active-value="1"
			 :inactive-value="0"
			   v-model="viewTag" @change="changeTag">
			 </el-switch>
		</el-descriptions-item>	
		<el-descriptions-item>
			<template slot="label">
				全局页脚
			</template>
			 <el-switch
			 :active-value="1"
			 :inactive-value="0"
			   v-model="viewFooter" @change="changeFooter">
			 </el-switch>
		</el-descriptions-item>				
	</el-descriptions>	
	</div>
</template>

<script>
	import {bgColorConfig,CreateCss} from '../utils/themecolor.js'
	import ThemePicker from './ThemePicker.vue'
	import store from '../store/index'
	import {
		updateThemeColor
	} from '../utils/theme'
	export default {
		components: {
			ThemePicker,
		},
		data() {
			return {
				bgColorConfig:bgColorConfig,
				themecolor:JSON.parse(localStorage.getItem('theme')).themecolor||0,
				menuLayout:store.state.settings.theme.menuLayout,
				defaulttheme:store.state.settings.theme.theme||'#409EFF',
				viewTag:store.state.settings.theme.viewTag,
				viewFooter:store.state.settings.theme.viewFooter,
			}
		},			
		methods: {
			themeChange(val) {
				this.$emit('themeChange',val)
				this.defaulttheme=val;
			},
			changeLayout(val) {
				this.$emit('changeLayout',val)
			},
           changeTheme(e){
			   let theme=JSON.parse(localStorage.getItem('theme'));
			   theme.themecolor=e;
			   store.dispatch('settings/changeSetting',theme)
			   this.themecolor=e;
			   CreateCss(e)
		   },
		   changeTag(e){
		   			   let theme=JSON.parse(localStorage.getItem('theme'));
		   			   theme.viewTag=e;
		   			   store.dispatch('settings/changeSetting',theme)
		   			   this.viewTag=e;
		   },
		   changeFooter(e){
		   			   let theme=JSON.parse(localStorage.getItem('theme'));
		   			   theme.viewFooter=e;
		   			   store.dispatch('settings/changeSetting',theme)
		   			   this.viewFooter=e;
		   }
		}
	}
</script>


<style>
	/**选择配色方案 */
	.ele-color .color-title {
	    padding: 10px 0 10px 20px;
	    border-bottom: 1px solid #d9dada;
	    margin-bottom: 8px;
	}	
	.ele-color .color-content {
	    padding: 10px 5px 0 5px;
	}	
	.ele-color .color-content ul {
	    list-style: none;
	    text-align: center;
	}	
	.ele-color .color-content ul li {
	    position: relative;
	    display: inline-block;
	    vertical-align: top;
	    width: 80px;
	    height: 50px;
	    margin: 0 15px 15px 0;
	    padding: 2px 2px 4px 2px;
	    background-color: #f2f2f2;
	    cursor: pointer;
	    font-size: 12px;
	    color: #666;
	}	
	.ele-color .color-content li.layui-this:after, .ele-color .color-content li:hover:after {
	    width: 100%;
	    height: 100%;
	    padding: 4px;
	    top: -5px;
	    left: -5px;
	    border-color: #d8d8d8;
	    opacity: 1;
	}
	
	.ele-color .color-content li:after {
	    content: '';
	    position: absolute;
	    z-index: 20;
	    top: 50%;
	    left: 50%;
	    width: 1px;
	    height: 0;
	    border: 1px solid #f2f2f2;
	    transition: all .3s;
	    -webkit-transition: all .3s;
	    opacity: 0;
	}
</style>